module.exports = __webpack_public_path__ + "img/hubinAppImage.9d3a61f2.png";